import { INTERIOR_COUNTRY_CODE } from '@/constants/config';
import { INTERIOR_PAYMENT_METHOD } from '@/constants/payment';
import { getClientCountryCode } from '@/services/guest.service';

export const GuestModule = {
    state: () => ({
        country: null,
        fetched: false,
        isGoogleSignInInitialized: false,
        googleSignInResponse: {},
    }),
    mutations: {
        setCountry(state, country) {
            state.country = country;
        },
        setFlag(state, data) {
            state.fetched = data;
        },
        setIsGoogleSignInInitialized(state, data) {
            state.isGoogleSignInInitialized = data;
        },
        setGoogleSignInResponse(state, data) {
            state.googleSignInResponse = data;
        },
    },
    actions: {
        async fetchCountry({ commit, state }, forceFetch = false) {
            if (!state.fetched || forceFetch) {
                try {
                    const { data } = await getClientCountryCode();
                    if (data && data.countryCode) {
                        commit('setCountry', data.countryCode);
                        commit('setFlag', true);
                    }
                } catch {
                    commit('setCountry', null);
                    commit('setFlag', false);
                }
            }
        },
    },
    getters: {
        country(state) {
            return state.country || '';
        },
        /**
         * Use to show company info
         * @param state
         * @param getters
         * @param rootState
         * @returns {any}
         */
        isInterior(state, getters, rootState) {
            const user = rootState.auth.user;

            if (user) {
                const usedMethods = user.paymentMethodUsed || [];
                return (
                    user.registerCountry ===
                        INTERIOR_COUNTRY_CODE[user.website.id] ||
                    (INTERIOR_PAYMENT_METHOD[user.website.id].length &&
                        INTERIOR_PAYMENT_METHOD[user.website.id].every((e) =>
                            usedMethods.includes(e)
                        )) ||
                    getters.country === INTERIOR_COUNTRY_CODE[user.website.id]
                );
            } else {
                return getters.country;
            }
        },
    },
    namespaced: true,
};
